import { render, staticRenderFns } from "./CertificateSlider.vue?vue&type=template&id=6a661c4a"
import script from "./CertificateSlider.vue?vue&type=script&lang=ts"
export * from "./CertificateSlider.vue?vue&type=script&lang=ts"
import style0 from "./CertificateSlider.vue?vue&type=style&index=0&id=6a661c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports